import React from 'react'

import { Alert as MuiAlert } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';
import { alpha } from '@mui/material/styles';

const normalizeSeverityByType = (type) => {
  const value = String(type || '').toLowerCase();

  switch (value) {
    case 'success':
      return 'success';
    case 'alert':
    case 'warning':
      return 'warning';
    case 'error':
      return 'error';
    case 'download':
    case 'info':
    default:
      return 'info';
  }
};

const renderMessage = (message) => {
  if (React.isValidElement(message)) {
    return message;
  }

  return <span>{String(message || '')}</span>;
};

const ToastAlert = ({ type, message, onClose }) => {
  const severity = normalizeSeverityByType(type);

  return (
    <MuiAlert
      severity={severity}
      variant='standard'
      icon={<CheckCircleOutline fontSize='inherit' />}
      onClose={onClose}
      sx={(theme) => {
        const palette = theme.palette[severity];

        return {
          width: 'fit-content',
          minWidth: 296,
          maxWidth: 'min(420px, calc(100vw - 32px))',
          minHeight: 50,
          px: 2,
          py: 0,
          alignItems: 'center',
          borderRadius: theme.shape.radii.md,
          backgroundColor: palette.light,
          color: theme.palette.text.primary,
          border: `1px solid ${alpha(palette.main, 0.24)}`,
          '& .MuiAlert-icon': {
            color: palette.main,
            mr: 1.5,
            py: 0,
          },
          '& .MuiAlert-message': {
            py: 0,
            overflowWrap: 'anywhere',
          },
          '& .MuiAlert-action': {
            py: 0,
            pl: 1.5,
            color: palette.main,
            alignItems: 'center',
          },
        };
      }}
    >
      {renderMessage(message)}
    </MuiAlert>
  )
}

export default ToastAlert
